import { render, staticRenderFns } from "./SolicitudesDevueltas.vue?vue&type=template&id=461eab4e"
import script from "./SolicitudesDevueltas.vue?vue&type=script&lang=js"
export * from "./SolicitudesDevueltas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports